import { render } from "./vworkorderlist.vue?vue&type=template&id=0540a142&scoped=true"
import script from "./vworkorderlist.vue?vue&type=script&lang=js"
export * from "./vworkorderlist.vue?vue&type=script&lang=js"

import "./vworkorderlist.vue?vue&type=style&index=0&id=0540a142&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0540a142"]])

export default __exports__